const cancelEvent = (evt) => {
  evt.nativeEvent?.target?.blur?.();
  evt.nativeEvent?.preventDefault?.();
  evt.nativeEvent?.stopPropagation?.();
  evt.nativeEvent?.stopImmediatePropagation?.();
  evt.target?.blur?.();
  evt.preventDefault?.();
  evt.stopPropagation?.();
};

export default cancelEvent;
